module.exports = __webpack_public_path__ + "static/media/child_icon.6d8aad7b.svg";